import React from 'react';

const Loader = () => (
    <div className="loader">
        <div className="ball-pulse-sync">
            <div />
            <div />
            <div />
        </div>
    </div>
);

export default Loader;
